import { Loading } from "@components/Loading";
import { useTranslation } from "@helpers/useTranslation";
import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useEventId } from "src/helpers/useEvent";
import { useEventNavigate } from "src/helpers/useEventNavigate";
import { useSimpleCollection } from "src/helpers/useSimpleCollection";
import { OracleNav } from "./OracleNav";

/** Associate picks the team in front of them. Lists all registered (non-uploader) teams with search. */
export const OracleTeamPicker = () => {
  const { t } = useTranslation("admin");
  const eventId = useEventId();
  const navigate = useEventNavigate();
  const { challengeId } = useParams();
  const [query, setQuery] = useState("");

  const [teams, loading] = useSimpleCollection<Team>(`events/${eventId}/teams`);

  const visibleTeams = useMemo(() => {
    const realTeams = teams.filter((team) => !team.isUploader);
    const q = query.trim().toLowerCase();
    const filtered = q
      ? realTeams.filter((team) => (team.displayName ?? team.name ?? "").toLowerCase().includes(q))
      : realTeams;
    return [...filtered].sort((a, b) => (a.displayName ?? a.name ?? "").localeCompare(b.displayName ?? b.name ?? ""));
  }, [teams, query]);

  return (
    <div className="flex min-h-screen flex-col">
      <OracleNav backLink="/oracle" />
      <main className="flex flex-1 flex-col items-center px-6 pb-24">
        <h1 className="mt-12 mb-6 text-center text-2xl font-semibold">{t("selectTeam")}</h1>
        <div className="w-full max-w-md">
          <input
            className="input-bordered input mb-4 w-full"
            placeholder={t("searchTeam")}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <Loading loading={loading}>
            <div className="flex flex-col gap-2">
              {visibleTeams.length === 0 && <div className="text-center text-sm text-gray-500">{t("noTeamsYet")}</div>}
              {visibleTeams.map((team) => (
                <button
                  key={team.id}
                  onClick={() => navigate(`/oracle/${challengeId}/teams/${team.id}`)}
                  className="btn-outline btn justify-between"
                >
                  <span>{team.displayName ?? team.name}</span>
                  <span className="text-sm text-gray-400">{team.points ?? 0}</span>
                </button>
              ))}
            </div>
          </Loading>
        </div>
      </main>
    </div>
  );
};
